(ns frontend.ui.component.lp-portal.report.component.horizontal-table.pdf-view
  (:require
   [common.util :as cu]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.view :refer [format-data]]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
   [frontend.ui.style.theme.core :as theme]))

(defn heading-row-spanned
  [heading color]
  (into []
        (->> heading
             :cols
             (keep (fn [{:keys [span label]}]
                     (let [hide-bottom-border? (= span 1)]
                       {:text      (or label "")
                        :colSpan   span
                        :rowSpan   (if (= span 1) 1 1)
                        :border    (when hide-bottom-border? [true true true false])
                        :fillColor color
                        :bold      (when-not (= (theme/get-theme) :theme.lp-portal/capman) "bold")
                        :color     (theme/color [:lp-report :table :pdf :heading-color :fg])
                        :alignment "center"}))))))

(defn heading-row-heading
  [heading headers heading-count color font-color data-types alignment-row]
  (let [hide-top-border? (->> headers
                              (filter (fn [{:keys [_cols header-type]}]
                                        (= header-type :header-type/spanned)))
                              (first)
                              :cols
                              (keep (fn [{:keys [span _label]}]
                                      (= span 1))))
        capman? (= (theme/get-theme) :theme.lp-portal/capman)]
    (into []
          (->> heading
               :cols
               (map-indexed
                (fn [idx lbl]
                  (let [column-alignment (nth alignment-row idx nil)]
                    {:text      (or lbl "")
                     :border    (cond capman?
                                      [false false false false]
                                      (and hide-top-border? (> heading-count 2))
                                      [true false true true]
                                      :else
                                      nil)
                     :fillColor color
                     :color     (or font-color 
                                    (theme/color [:lp-report :table :pdf :heading-color :fg]))
                     :bold      (when-not capman? "bold")
                     :alignment (cond
                                  (not (cu/blank-value? column-alignment))
                                  column-alignment
                                  (= idx 0)
                                  "left"
                                  :else
                                  (case (nth data-types idx)
                                    :table-data-type/date
                                    "right"
                                    :table-data-type/currency
                                    "right"
                                    :table-data-type/multiple
                                    "right"
                                    :table-data-type/number
                                    "right"
                                    :table-data-type/percentage
                                    "right"
                                    :table-data-type/text
                                    "left"
                                    "right"))})))
               (vec)))))

(defn heading-row-info
  [heading color data-type]
  (into []
        (->> heading
             :cols
             (mapv
              (fn [lbl]
                {:text      (or lbl "")
                 :fillColor color
                 :color     (theme/color [:lp-report :table :pdf :heading-info-color :fg])
                 :alignment (case data-type
                              :table-data-type/date
                              "right"
                              :table-data-type/currency
                              "right"
                              :table-data-type/multiple
                              "right"
                              :table-data-type/number
                              "right"
                              :table-data-type/percentage
                              "right"
                              :table-data-type/text
                              "left"
                              "right")})))))

(defn heading-rows
  [headers heading-count heading-color heading-font-color heading-info-color data-types alignment-row]
  (->> headers
       (map-indexed (fn [idx header-row]
                      (let [header-type (:header-type header-row)]
                        (case header-type
                          :header-type/spanned
                          (heading-row-spanned header-row heading-color)
                          :header-type/info
                          (heading-row-info header-row heading-info-color (nth data-types idx))
                          :header-type/heading
                          (heading-row-heading header-row headers heading-count heading-color heading-font-color data-types alignment-row)
                          (str "No header type " (:header-type header-row))))))
       (vec)))

(defn data-row
  [{:keys [column-data-types column-decimals column-multipliers _pdf-widths-row alignment-row highlight-row
           empty-indicator-row text-style-row format-row column-style-row _headers
           _heading-count _rows table-style]
    :as   _parsed-data}
   {:keys [row-data row-highlight row-type row-font-style row-style row-pdf-page-break] :as _row}
   {:keys [odd-color even-color row-index subheading-color subtotal-color total-color empty-line-color icons-row
           font-size]}]
  (into
   []
   (->>
    column-data-types
    (map-indexed
     (fn [idx col-data-type]
       (let [column-decimal (nth column-decimals idx nil)
             column-multiplier (nth column-multipliers idx nil)
             column-date-format (nth format-row idx nil)
             column-alignment (nth alignment-row idx nil)
             column-color (nth highlight-row idx nil)
             column-text-style (nth text-style-row idx nil)
             column-empty-indicator (nth empty-indicator-row idx nil)
             column-style (nth column-style-row idx nil)
             default-cell-borders (case row-type
                                    "subtotal" [false true false true]
                                    "total" (if (= (theme/get-theme) :theme.lp-portal/lifeline) 
                                              [false true false false]
                                              [false true false true])
                                    [false false false false])
             icon-map (nth icons-row idx nil)]
         {:text [{:text (str (format-data col-data-type
                                          column-decimal
                                          column-multiplier
                                          column-date-format
                                          column-empty-indicator
                                          row-type
                                          (nth row-data idx nil))
                             (when icon-map " "))
                  :color "#000000"
                  :fontSize (cond (not (cu/blank-value? font-size))
                                  font-size
                                  (= (theme/get-theme) :theme.lp-portal/capman)
                                  9
                                  :else
                                  (if (> (count column-data-types) 14)
                                    5
                                    6))}
                 (when icon-map {:text (:icon icon-map)
                                 :font "FontAwesome"
                                 :color (:color icon-map)
                                 :fontSize 6})]
          :color     "#000000"
          :fillColor (cond
                       (and (not (cu/blank-value? column-color)) (cu/blank-value? row-highlight))
                       column-color
                       (and (cu/blank-value? column-color) (not (cu/blank-value? row-highlight)))
                       row-highlight
                       (and (not (cu/blank-value? column-color)) (not (cu/blank-value? row-highlight)))
                       column-color ;;Column color is always on top of row color
                       (not (cu/blank-value? row-type))
                       (case row-type
                         "subheading"
                         subheading-color
                         "subtotal"
                         subtotal-color
                         "total"
                         total-color
                         "empty line"
                         empty-line-color)
                       (= table-style :table-style/none)
                       even-color
                       :else
                       (if (odd? row-index) odd-color even-color))
          :bold      (when-not (and (cu/blank-value? column-text-style) (cu/blank-value? row-font-style))
                       (or (= "bold" (cu/str-trim-lcase column-text-style))
                           (= "bold" (cu/str-trim-lcase row-font-style))))
          :italics   (when-not (and (cu/blank-value? column-text-style) (cu/blank-value? row-font-style))
                       (or (= "italic" (cu/str-trim-lcase column-text-style))
                           (= "italic" (cu/str-trim-lcase row-font-style))))
          :alignment (if-not (cu/blank-value? column-alignment)
                       column-alignment
                       (case col-data-type
                         :table-data-type/date
                         "right"
                         :table-data-type/currency
                         "right"
                         :table-data-type/multiple
                         "right"
                         :table-data-type/number
                         "right"
                         :table-data-type/percentage
                         "right"
                         :table-data-type/text
                         "left"
                         "right"))
          :border
          (cond-> default-cell-borders
            (= column-style "border left")
            (assoc 0 true)
            (= row-style "border top")
            (assoc 1 true)
            (= column-style "border right")
            (assoc 2 true)
            (= row-style "border bottom")
            (assoc 3 true))
          :pageBreak row-pdf-page-break}))))))


(defn horizontal-table-pdf
  [{:keys [parsed-data odd-row-background-color even-row-background-color heading-color heading-font-color heading-info-color
           subheading-color subtotal-color total-color empty-line-color font-size table-widths]
    :as   _params}]
  (let [{:keys [heading-count headers rows pdf-widths-row column-data-types icon-config-table alignment-row]} parsed-data
        last-heading-idx (atom 0)
        heading-indexes (range (+ heading-count 1))
        heading-border-color-horizontal (fn [i]
                                          (cond
                                            (some #{i} heading-indexes)
                                            (theme/color [:lp-report :table :pdf :heading-border])
                                            (= (theme/get-theme) :theme.lp-portal/capman)
                                            "#d3d3d3"
                                            :else
                                            (theme/color [:palette :brand-3]))) ;;NOTE this color is for other borders, eg. subtotals
        heading-border-color-vertical (fn [_i]
                                          (cond
                                            (= (theme/get-theme) :theme.lp-portal/lifeline)
                                            (theme/color [:palette :granite])
                                            (= (theme/get-theme) :theme.lp-portal/capman)
                                            "#d3d3d3"
                                            :else
                                            (theme/color [:lp-report :table :pdf :heading-border])))
        full-width (vec (repeat (count column-data-types) "*"))
        line-width (cond (= (theme/get-theme) :theme.lp-portal/capman)
                         0.8
                         :else
                         0.5)
        table-config {:layout   (merge {:hLineColor heading-border-color-horizontal
                                        :vLineColor heading-border-color-vertical
                                        :hLineWidth (fn [i]
                                                      (if (and (= (theme/get-theme) :theme.lp-portal/lifeline)
                                                               (some #{i} heading-indexes))
                                                        0
                                                        line-width))
                                        :vLineWidth (fn [_i] line-width)}
                                       (when (= (theme/get-theme) :theme.lp-portal/capman)
                                         {:paddingTop (fn [_i] 4)
                                          :paddingBottom (fn [_i] 0)}))
                      :color    ()
                      :fontSize (cond (not (cu/blank-value? font-size))
                                      font-size
                                      (= (theme/get-theme) :theme.lp-portal/capman)
                                      9
                                      :else
                                      (if (> (count column-data-types) 14)
                                        5
                                        6))
                      :margin   [0 0 0 0]
                      :table    {:widths (cond
                                           table-widths
                                           table-widths
                                           (or (empty? pdf-widths-row) (some #(= nil %) pdf-widths-row))
                                           full-width
                                           :else
                                           pdf-widths-row)
                                 :headerRows heading-count
                                 :body       (concat
                                              (heading-rows headers
                                                            heading-count
                                                            heading-color
                                                            heading-font-color
                                                            heading-info-color
                                                            column-data-types
                                                            alignment-row)
                                              (concat
                                               (->> rows
                                                    (map-indexed (fn [row-index row]
                                                                   (let [row-type (:row-type row)
                                                                         icons-row (when icon-config-table
                                                                                     (nth (->> icon-config-table
                                                                                               (drop heading-count))
                                                                                          row-index))
                                                                         row-idx (if (some #(= row-type %)
                                                                                           ["subheading" "subtotal"
                                                                                            "empty line" "total"])
                                                                                   (do (reset! last-heading-idx row-index) 0)
                                                                                   (- row-index @last-heading-idx))]
                                                                     (data-row parsed-data
                                                                               row
                                                                               {:odd-color  odd-row-background-color
                                                                                :even-color even-row-background-color
                                                                                :row-index                   row-idx
                                                                                :subheading-color          subheading-color
                                                                                :subtotal-color            subtotal-color
                                                                                :total-color               total-color
                                                                                :empty-line-color          empty-line-color
                                                                                :icons-row                 icons-row
                                                                                :font-size                font-size})))))))}}]
    table-config))


(defn table
  ([data] (table data {}))
  ([data props]
   (let [removed-since-empty? (->> data
                                   :figures
                                   :rows
                                   (filter (fn [{:keys [row-data]}]
                                             (seq (remove nil? row-data))))
                                   (count)
                                   (= 0))]
     (if removed-since-empty?
       nil
       (card/card
        (or (:title props) "")
        (horizontal-table-pdf
         {:parsed-data              (:figures data)
          :odd-row-background-color (if removed-since-empty?
                                      (theme/color [:palette :danger])
                                      (theme/color [:lp-report :table :pdf :odd-row :bg]))
          :even-row-background-color (theme/color [:lp-report :table :pdf :even-row :bg])
          :heading-color            (or (:custom-heading-color props) 
                                        (theme/color [:lp-report :table :pdf :heading-color :bg]))
          :heading-font-color            (or (:custom-heading-font-color props)
                                             (theme/color [:lp-report :table :pdf :heading-color :fg]))
          :heading-info-color       (theme/color [:lp-report :table :pdf
                                                  :heading-info-color :bg])
          :subheading-color         (theme/color [:lp-report :table :pdf
                                                  :subheading-color :bg])
          :subtotal-color           (theme/color [:lp-report :table :pdf
                                                  :subtotal-color :bg])
          :total-color              (theme/color [:lp-report :table :pdf
                                                  :total-color :bg])
          :empty-line-color         (theme/color [:lp-report :table :pdf
                                                  :empty-line-color :bg])
          :font-size                (:font-size props)
          :table-widths             (:table-widths props)}))))))

(defn dynamic-horizontal-table-pages
  "Paginate a PDF table using horizontal-table-pdf for each page"
  ([page-title-params title data]
   (dynamic-horizontal-table-pages page-title-params title data {}))
  ([page-title-params title data opts]
   (dynamic-horizontal-table-pages page-title-params title data opts {}))
  ([_page-title-params title data opts _footer-opts]
   (let [partition-size (get opts :partition-size 25)
         partitions (some->>
                     data
                     :figures
                     :rows
                     ;; Drop empty lines from end
                     (reverse)
                     (drop-while (fn [row] (every? nil? (vals row))))
                     (reverse)
                     (partition partition-size partition-size nil)
                     (seq))
         partition-count (count partitions)]
     (some->>
      partitions
      (map-indexed (fn [idx page-batch]
                     (let [batch-data (-> data
                                          (assoc-in [:figures :rows] page-batch))
                           batch-data (if (not= idx (dec partition-count))
                                        (dissoc batch-data :rich-content)
                                        batch-data)
                           first-batch? (= 0 idx)]
                       (page/page
                        (if (:vertical-layout? opts)
                          (page/page-title-vertical-layout
                           {:fund-name  (:fund-name data)
                            :page-title (:page-title opts)
                            :toc-item (and (:toc-item opts) first-batch?)})
                          nil)
                        [(table batch-data (merge opts {:title (when-not (cu/blank-value? title)
                                                                (str title (when (< 1 partition-count)
                                                                             (str " (" (inc idx) "/" partition-count ")"))))}))
                         (when (= idx (dec partition-count)) 
                           (text-content/optional-footer data))]))))))))
